<template>
  <v-container>
    <div>
      <div class="title-icon">
        <h1>{{ $t('order-card.start') }}</h1>
        <!--  <v-btn
          :class="[$vuetify.breakpoint.xsOnly ? (isCompanyOrder ? 'special-icon-card-top' : 'mt-n12') : '']"
          icon
          target="_blank"
        >
          <v-icon>$sl-question</v-icon>
        </v-btn> -->
      </div>

      <p>
        {{ $t('order-card.start-info') }}
      </p>
    </div>

    
    <p class="overline small mt-8" v-if="(educations && educations.length > 0) || (currentUser && currentUser.tradeCertificates && currentUser.tradeCertificates.length>0)">
      {{ $t('order-card.can-do') }}
    </p>

    <template v-if="showMachineBtn || (currentUser && currentUser.tradeCertificates && currentUser.tradeCertificates.length>0)">
      <ActionButton v-if="showMachineBtn" @click="goTo('machine-card')" class="mt-n2" actionIcon="$sl-equipment-truck">{{
        $t('order-card.btn-machine-card')
      }}</ActionButton>
      <ActionButton v-if="currentUser && currentUser.tradeCertificates && currentUser.tradeCertificates.length>0"  class="mt-4" actionIcon="$sl-invitation" @click="goTo('tradecertificate-card')">
          {{ $t('order-card.btn-tradecertificate-card') }}
      </ActionButton>
    </template>
    <!-- if can not order show error -->
    
    <p v-else class="mt-5">
      {{ $t('order-card.no-prof-text2') }}
    </p>    
  </v-container>
</template>

<script>
import API from '@/services/api.js'
import ActionButton from '@/components/Common/ActionButton'
import {mapActions, mapGetters} from 'vuex'
import {CompanyRoles} from '@/components/mixins'
import {RulesMixin} from '@/components/mixins'
import get from 'lodash/get'
import uniq from 'lodash/uniq'
import find from 'lodash/find'

export default {
  name: 'CompanyPausedPersons',
  mixins: [CompanyRoles, RulesMixin],

  components: {
    ActionButton
  },
  data: () => ({
    educations: [],        
    showMachineBtn: false,
    hasQualTime: false
  }),
  watch: {
    
  },
  created() {
    this.init()
  },

  computed: {
    ...mapGetters('currentuser', ['currentUser', 'isInstructor', 'isAdministrator', 'isCompanyUser']),
    ...mapGetters('basic', ['hasProfessionOrientations']),        
  },

  methods: {
    init() {      
      this.getApprenticeQTime()      
    },

    getApprenticeQTime() {
      this.showMachineBtn = false            
            
      if (!this.currentUser.id) return
      API.getQualifyingTime(this.currentUser.id)
        .then(({data = {}}) => {
          const {educations = []} = data
          this.educations = educations
          this.educations.forEach(ed => {
            if (this.hasProfessionOrientations(ed.professionId) == true) {
              return (this.showMachineBtn = true)
            }
          })
        })
        .catch(error => {
          console.log('Error getting person QT:', error)
        })
    },
    goTo(type) {            
      this.$nextTick(() => {
          this.$router.push({
            name: 'CardTypes',
            params: {personId: this.currentUser.id, type: type}
        })
      })
    }
  }
}
</script>
<style scoped>
.special-icon-card-top {
  margin-top: -100px !important;
}
</style>
